import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-crm-resync-warning-dialog',
    templateUrl: './crm-resync-warning-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CrmResyncWarningDialogComponent {

}
